
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface ExtraServicesSectionProps {
  services: string[];
}

const ExtraServicesSection = ({ services }: ExtraServicesSectionProps) => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="border-2 border-blue-100">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl font-bold text-gray-900">
              Además, nos encargamos de
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {services.map((servicio, idx) => (
                <div key={idx} className="flex items-start">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <span className="text-gray-700">{servicio}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ExtraServicesSection;
